import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/product',
        name: 'ProductView',
        component: () => import('../views/ProductView.vue'),
        meta: { keepAlive: true }
    },
    {
        path: '/product/productId/:productId',
        name: 'productDetails',
        component: () => import("../views/ProductDetailsView.vue")
    },
    {
        path: '/example',
        name: 'example',
        component: () => import('../views/ExampleView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    }
    ,
    {
        path: '/addProduct',
        name: 'addProduct',
        component: () => import('../views/AddProductView.vue')
    },

    // ========== 后台管理 ==========
    {
        path: '/admin/login',
        name: 'adminLogin',
        component: () => import('../views/admin/LoginView.vue')
    },
    {
        path: '/admin',
        component: () => import('../layouts/AdminLayout.vue'),
        redirect: '/admin/dashboard',
        children: [
            { path: 'dashboard',    name: 'adminDashboard',   component: () => import('../views/admin/DashboardView.vue'),     meta: { requiresAuth: true, title: '控制台' } },
            { path: 'products',     name: 'adminProducts',    component: () => import('../views/admin/ProductManage.vue'),     meta: { requiresAuth: true, title: '商品管理' } },
            { path: 'statistics',   name: 'adminStatistics',  component: () => import('../views/admin/StatisticsView.vue'),    meta: { requiresAuth: true, title: '访问统计' } },
            { path: 'users',        name: 'adminUsers',       component: () => import('../views/admin/UserManage.vue'),        meta: { requiresAuth: true, title: '用户管理' } },
            { path: 'roles',        name: 'adminRoles',       component: () => import('../views/admin/RoleManage.vue'),        meta: { requiresAuth: true, title: '角色管理' } },
            { path: 'permissions',  name: 'adminPermissions', component: () => import('../views/admin/PermissionManage.vue'),  meta: { requiresAuth: true, title: '权限管理' } },
        ]
    }
]

const router = new VueRouter({
    // mode: 'history',  // 添加 mode: 'history'
    routes,
})

// 全局前置守卫：后台页面需登录
router.beforeEach((to, from, next) => {
    if (to.matched.some(r => r.meta && r.meta.requiresAuth)) {
        const loggedIn = !!sessionStorage.getItem('portal_logged_in');
        if (!loggedIn) {
            next({ path: '/admin/login' });
            return;
        }
    }
    next();
})

export default router
